<nb-card>
  <nb-card-header>
    <div class="d-flex align-items-center">
      <i class="far fa-chart-line ms-2"></i>
      <span>گزارش‌گیری</span>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="row mb-4">
      <div *ngIf="!userId" class="col-12 col-lg-6">
        <nb-card>
          <nb-card-header>فقط کاربران لیست</nb-card-header>
          <nb-card-body>
            <app-user-picker
              (add)="includedUsers = $event"
              (remove)="includedUsers = $event"
              [cacheKey]="'transaction_included_users'"
            ></app-user-picker>
          </nb-card-body>
        </nb-card>
      </div>
      <div *ngIf="!userId" class="col-12 col-lg-6">
        <nb-card>
          <nb-card-header>به جز کاربران لیست</nb-card-header>
          <nb-card-body>
            <app-user-picker
              (add)="excludedUsers = $event"
              (remove)="excludedUsers = $event"
              [cacheKey]="'transaction_excluded_users'"
            ></app-user-picker>
          </nb-card-body>
        </nb-card>
      </div>
      <div class="col-12 col-lg-6 col-xxl-2">
        <div class="row mb-3 align-items-center">
          <label class="col-12 mb-2">نوع تراکنش</label>
          <div class="col-12">
            <nb-select
              placeholder="نوع تراکنش"
              fullWidth
              id="type"
              [(selected)]="type"
              [status]="error['type'] === undefined ? 'basic' : 'danger'"
            >
              <nb-option [value]="'all'">همه</nb-option>
              <nb-option [value]="'trade'">معامله</nb-option>
              <nb-option [value]="'deposit'">واریز</nb-option>
              <nb-option [value]="'withdraw'">برداشت</nb-option>
            </nb-select>
            <app-validation-error [errors]="error" name="type"></app-validation-error>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xxl-2">
        <div class="row mb-3 align-items-center">
          <label class="col-12 mb-2">بازار</label>
          <div class="col-12">
            <nb-select
              placeholder="بازار"
              fullWidth
              id="market"
              [(selected)]="market"
              [status]="error['market'] === undefined ? 'basic' : 'danger'"
            >
              <nb-option [value]="'real'">واقعی</nb-option>
              <nb-option [value]="'demo'">دمو</nb-option>
            </nb-select>
            <app-validation-error [errors]="error" name="type"></app-validation-error>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xxl-8">
        <div class="d-flex align-items-center gap-3 mb-2">
          ارز
          <nb-toggle (checkedChange)="$event ? currencySelector.selectAll() : currencySelector.deselectAll()">انتخاب
            همه
          </nb-toggle>
        </div>
        <app-select-currency
          [multiple]="true"
          [selectAllExceptIRR]="false"
          #currencySelector
          (currency)="currencies = $event; this.filterTable()"
        ></app-select-currency>
        <app-validation-error [errors]="error" name="currency"></app-validation-error>
      </div>
    </div>
    <app-range-picker *ngIf="!userId"
                      (submit)="filterTable($event)"></app-range-picker>
    <button nbButton status="primary" (click)="filterTable()" [disabled]="tableLoading" [nbSpinner]="tableLoading"
            *ngIf="userId">
      گزارش گیری
    </button>
  </nb-card-body>
</nb-card>
<nb-card>
  <nb-card-header>
    <div class="d-flex align-items-center">
      <i class="fal fa-money-check ms-2"></i>
      <ng-container *ngIf="!userId">تراکنش های کاربران</ng-container>
      <ng-container *ngIf="userId">تراکنش های کاربر</ng-container>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div>
        <nb-select
          class="ms-2"
          [selected]="15"
          (selectedChange)="changeRecordPerPageLimit($event)"
          placeholder="تعداد نمایش"
        >
          <nb-option [value]="10">10</nb-option>
          <nb-option [value]="15">15</nb-option>
          <nb-option [value]="25">25</nb-option>
          <nb-option [value]="50">50</nb-option>
          <nb-option [value]="100">100</nb-option>
        </nb-select>
        <button *ngIf="userId" nbButton status="info" [nbSpinner]="contradictionLoading"
                [disabled]="contradictionLoading"
                (click)="getContradictionTable()">مغایرت گیری
        </button>
      </div>
    </div>
    <p-table
      [value]="pagination.data"
      [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
      [lazy]="false"
      [alwaysShowPaginator]="false"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="limit"
      [totalRecords]="pagination.data.length"
      [loading]="tableLoading"
      [(first)]="first"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>نوع تراکنش</th>
          <th *ngIf="!userId">کاربر</th>
          <th>ارز</th>
          <th>مقدار</th>
          <th>موجودی</th>
          <th>توضیحات</th>
          <th>تاریخ ایجاد</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-transaction>
        <tr>
          <td
            [ngClass]="{'text-danger' : transaction.type === TransactionType.WITHDRAW, 'text-primary' : transaction.type === TransactionType.DEPOSIT}"
            *ngIf="transaction.type">
            {{transaction.type | transaction}}
          </td>
          <td *ngIf="!userId">
            <a class="text-primary" *ngIf="transaction.user?.firstName;else emptyName"
               routerLink="/dashboard/user/{{transaction.user.id}}">
              {{transaction.user.firstName}} {{transaction.user.lastName}}
            </a>
            <ng-template #emptyName>
              -
            </ng-template>
          </td>
          <td>
            {{transaction.currency.name}}
          </td>
          <td>
            <bdi
              [ngClass]="{'text-danger' : transaction.amount < 0, 'text-primary' : transaction.amount > 0}"> {{ transaction.amount  | number:'1.0-' + (transaction.currency.id === 'IRR' ? 0 : 8)}}</bdi>
          </td>
          <td>
            <bdi>
              {{transaction.balance | number: '1.0-' + (transaction.currency.id === 'IRR' ? 0 : 8)}}

            </bdi>
          </td>
          <td>
            {{transaction.description ?? '-'}}
          </td>
          <td>
            {{ transaction.createdAt ? (transaction.createdAt | dateFormat: 'HH:mm jYYYY/jMM/jDD') : '-' }}
          </td>
        </tr>
        <ng-template #empty>
          <td>-</td>
        </ng-template>
      </ng-template>
    </p-table>

    <div *ngIf="tableLoading" class="loading-backdrop">
      <i class="fal fa-circle-notch fa-spin fa-3x"></i>
    </div>
  </nb-card-body>
</nb-card>
